import { render, staticRenderFns } from "./TabPPP3History.vue?vue&type=template&id=2494bac1"
import script from "./TabPPP3History.vue?vue&type=script&lang=js"
export * from "./TabPPP3History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports